export const GET_USER = "GET_USER";
export const BLOCK_UNBLOCK_SWITCH = "BLOCK_UNBLOCK_SWITCH";

export const GET_HISTORY = "GET_HISTORY";

export const EDIT_COIN = "EDIT_COIN";

export const GET_USER_BAN = "GET_USER_BAN";

export const OPEN_BAN_USER_DIALOG = "OPEN_BAN_USER_DIALOG";
export const CLOSE_BAN_USER_DIALOG = "CLOSE_BAN_USER_DIALOG";

export const ADJUST_DAILY_DIAMOND_CAP = "ADJUST_DAILY_DIAMOND_CAP";
export const TOGGLE_USER_VERIFICATION = "TOGGLE_USER_VERIFICATION";
export const RESET_USER_IDENTITY = "RESET_USER_IDENTITY";

export const OPEN_DAILY_DIAMOND_LIMIT_DIALOG = "OPEN_DAILY_DIAMOND_LIMIT_DIALOG";
export const CLOSE_DAILY_DIAMOND_LIMIT_DIALOG = "CLOSE_DAILY_DIAMOND_LIMIT_DIALOG";
export const SET_DAILY_DIAMOND_LIMIT_DIALOG_DATA = "SET_DAILY_DIAMOND_LIMIT_DIALOG_DATA";
